import {NgModule} from '@angular/core';
import {DatePipe} from './pipes/date.pipe';
import {TimePipe} from './pipes/time.pipe';
import {SecondsToTime} from './pipes/seconds.to.time.pipe';

@NgModule({
  declarations: [
    DatePipe,
    TimePipe,
    SecondsToTime
  ],
  exports: [
    DatePipe,
    TimePipe,
    SecondsToTime
  ]
})
export class DateTimeModule { }
